// events defined here are formatted for GTM
export default {
  // Get info about product using product handle
  getProductByHandle (productHandle) {
    // remove any extra bits
    const cleanHandle = productHandle.split('?')[0]
    return new Promise((resolve, reject) => {
      fetch(`/products/${cleanHandle}.js`)
        .then((response) => {
          // console.log('Product info response:', response)
          return response.json()
        })
        .then((data) => {
          // console.log('Product info data:', data)
          resolve(data)
        })
        .catch((err) => {
          console.error('get product info error:', err)
          reject(err)
        })
    })
  },

  getProductById (productId) {
    return new Promise((resolve, reject) => {
      fetch(`/products/${productId}.json`)
        .then((response) => {
          // console.log('Product info response:', response)
          return response.json()
        })
        .then((data) => {
          // console.log('Product info data:', data)
          resolve(data)
        })
        .catch((err) => {
          console.error('get product info error:', err)
          reject(err)
        })
    })
  },

  pushProductClickEvent (data, productList, position, targetUrl) {
    const newData = {
      click: {
        actionField: { productList },
        products: []
      }
    }

    newData.click.products.push({
      id: data.id,
      name: data.title,
      price: data.price / 100,
      brand: data.vendor,
      category: data.type,
      variant: data.title,
      position
    })

    // clear previous object
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'productClick',
      ecommerce: newData
    })
    document.location = targetUrl
  }
}
